/**
 @author xiaoye
 @date 2020/4/10 7:53 下午
 */


import store from '@/store';
import Vue from 'vue'
import {comLegend, comColor} from "../../script/comChart";
import jsonVal from "./json/data.json";

let vm = new Vue();
let vuex = store.state;

export default {
    //类型
    type: 'radar',
    //类别
    class: 'chart',
    //组件名称
    name: '雷达图',
    //排序
    sort: 5,
    //图标
    iconImg: '/img/leida.png',
    //大屏图标
    bigIconImg: '/img/leida.png',
    //是否在多维分析展示
    viewType: true,
    //基础配置
    option: {
        //最小维度数量
        minWDLength: 1,
        //最小度量数量
        minDLLength: 1,
        //最大维度数量
        maxWDLength: 1,
        //最大度量数量
        maxDLLength: 10,
        //高
        dp_height: 250,
        //宽
        dp_wight: 300,
        //最小高
        dp_min_height: 50,
        //最小宽
        dp_min_wight: 50,
        //是否展示维度配置
        isWdConfig: true,
        //是否展示度量配置
        isDlConfig: true,
        //是否展示JSON配置
        isJSONConfig: true,
        //是否展示公共配置
        isComConfig: true,
        //是否展示边框
        isComBorder: true,
    },
    // 子集展示的配置项
    chilCharts: [
        {
            name: '雷达图',
            ordImg: '/img/leida.png',
            bigImg: '/img/leida.png',
            //默认配置
            chartParam: {},
            //维度配置
            wdParam: {},
            //度量配置
            dlParam: {
                stack: ''
            },
        },
    ],
    //维度组件
    wdComponent: null,
    //维度参数
    wdHandle(option) {
        return {}
    },
    //度量组件
    dlComponent: () => import('./dlParam/dlParam'),
    //度量参数
    dlHandle(option) {
        return {
            //堆叠
            stack: '123',
            //颜色
            color: '',
            //自定义
            customColor: false,
            //数值
            label: {
                show: false,
            },
            //主次轴
            lTAxis: 0,

            //线条和面积
            areaStyle: {
                color: '',
                shadowBlur: '',
                shadowColor: '',
            }

        }
    },
    //配置参数
    params(option) {
        return {
            //图例配置
            legend: {
                show: true,
                position: 'leftTop',
                font: {
                    color: vuex.dpType === 1 ? '#fff' : '#333',
                    size: 14,
                },
                //间隔
                marInterval: 15,
                orient:'horizontal'

            },
            //雷达盘配置
            radar: {
                name: {
                    show: true,
                    textStyle: {
                        color: '#fff',
                        fontSize: 14,
                        backgroundColor: '#999',
                        padding: [3, 4]
                    }
                },
                //半径
                radius: 70,
                //数据占据雷达盘比例
                proportion:1.2,
                //起始角度
                startAngle: 90,
                //底面形状 circle圆形 polygon多边形
                shape: 'polygon',
                //方向线
                axisLine: {
                    lineStyle: {
                        color: 'rgba(0,255,103,0.5)'
                    }
                },
                //指示器分割段数
                splitNumber: 8,
                //指示器线
                splitLine: {
                    lineStyle: {
                        color: 'rgba(0,56,255,0.5)',
                        width:1,
                        type:'solid'
                    }
                },
                //指示器面
                splitArea: {
                    areaStyle: {
                        //底色
                        colorName: '蓝色系',
                        color: ['rgba(114, 172, 209, 0.2)', 'rgba(114, 172, 209, 0.4)', 'rgba(114, 172, 209, 0.6)',
                            'rgba(114, 172, 209, 0.8)', 'rgba(114, 172, 209, 1)'],
                    }
                },
            }
        }
    },
    //配置组件列表
    configModule: [
        {
            name: '图例配置',
            component: () => import('../../comConfig/comLegend/comLegend.vue')
        },
        {
            name: '雷达盘配置',
            component: () => import('./config/radar_config.vue')
        },
    ],
    //接口
    JSONData: {
        //静态数组
        listDaVal: jsonVal,
        //接口参数
        params: {
            //维度
            wd: ['维度'],
            //度量
            dl: ['度量1']
        },
        //引用的组件
        jsonPonent: () => import('./json/json'),
    },
    //静态转换数据回调
    JSONRender(json, chart, nowChart, viewDP) {
        try {
            let setChart = chart.setting;
            let params = nowChart.comParam.JSONData.params;
            let dl = params.dl;
            let wd = params.wd;
            let dlStyParam = setChart.dlStyParam;
            let wdStyParam = setChart.wdStyParam;
            let head = {
                listWD: [],
                listZB: []
            };
            let dt = JSON.parse(json);
            wd.map((item, index) => {
                if (!item) {
                    return;
                }
                let count = 0;
                for (let i of setChart.wdList) {
                    if (i.name === item) {
                        count = 1;
                        break;
                    }
                }
                head.listWD.push({
                    alias: item,
                    filed: item
                });
                if (count === 0) {
                    let data = {
                        name: item,
                        config: JSON.parse(JSON.stringify(viewDP.comWDConfig)),
                        params: JSON.parse(JSON.stringify(wdStyParam[index] || nowChart.comPonent.wdParams))
                    };
                    data.config.alias = item;
                    setChart.wdList.push(data)
                }
            });
            dl.map((item, index) => {
                if (!item) {
                    return;
                }
                let count = 0;
                for (let i of setChart.dlList) {
                    if (i.name === item) {
                        count = 1;
                        break;
                    }
                }
                head.listZB.push({
                    alias: item,
                    filed: item
                });
                if (count === 0) {
                    let data = {
                        name: item,
                        config: JSON.parse(JSON.stringify(viewDP.comDLConfig)),
                        params: JSON.parse(JSON.stringify(dlStyParam[index] || nowChart.comPonent.dlParams))
                    };
                    data.config.alias = item;
                    setChart.dlList.push(data)
                }
            });
            let JkData = {
                dataTabel: {
                    dt: dt,
                    head: head
                },
                totalCount: dt.length
            };
            chart.data = JkData;
        } catch (e) {
            chart.data = {};
        }
    },
    //切换图表之前的回调
    renderBefore(chart, nowChart, dom) {
        nowChart.comConfig.gridType = 1;
        let echart = echarts.init(dom);
        echart.dispose()
        echart = null;
    },
    //渲染
    rendering(chart, nowChart, dom) {
        //chart 数据  now现在的数据

        // dataAll dt数据  和别名head
        let dataAll = JSON.parse(JSON.stringify(chart.data.dataTabel));
        let config = chart.setting;
        let comConfig = nowChart.comConfig;
        let echart = echarts.init(dom);
        let params = config.params;
        let wdParams = config.wdList;
        let dlParams = config.dlList;
        //维度
        let wd = dataAll.head.listWD;
        //度量
        let dl = dataAll.head.listZB;
        //颜色
        let colorList = JSON.parse(JSON.stringify(comColor(comConfig.colorIndex)));

        //数据 转换成正常格式
        let dataVal = dataAll.dt;
        dataVal.map((item, index) => {
            let da = {};
            for (let i in item) {
                da[i.toLowerCase()] = item[i];
            }
            dataVal[index] = da;
        });

        //
        let legendList = [];

        if (dataAll.dt.length > comConfig.valLength) {
            dataAll.dt.length = nowChart.comConfig.valLength;
        }

        //获取度量数据
        let dlVal = [];
        let maxList = [];
        dl.map((i, index) => {
            let configDL = {};
            dlParams.map((c) => {
                if (c.name === i.filed) {
                    configDL = c;
                }
            });
            let node = {
                value: [],
                name: i.alias,
                aliasNmae: i.filed,
                config: configDL,
                areaStyle: {
                    color: configDL.params.areaStyle.color,
                    shadowBlur: configDL.params.areaStyle.shadowBlur,
                    shadowColor: configDL.params.areaStyle.shadowColor,
                }
            };
            node.value = dataVal.map((item) => {
                maxList.push(item[i.alias]);
                if (configDL.params.customColor) {
                    colorList[index] = configDL.params.color;
                    return item[i.alias] || 0
                } else {
                    return item[i.alias] || 0
                }
            });
            dlVal.push(node);
            legendList.push(i.alias);
        });
        //获取维度数据
        let wdVal = [];
        dataVal.map((item) => {
            wdVal.push({
                name: item[wd[0].alias],
                max: Math.max(...maxList) * params.radar.proportion
            })
        });

        /*
              dlVal 度量单独数据及配置
              wdVal 维度单独数据
              legendList 度量别名数组
              dataVal 数据数组
              */
        // console.log(dlVal);
        // console.log(wdVal);
        // console.log(legendList);
        // console.log(dataVal);

        let option = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    label: {
                        show: true
                    }
                }
            },
            legend: comLegend(params.legend, legendList),
            color: colorList,
            radar: params.radar,
            series: [{
                type: 'radar',
                // areaStyle: {normal: {}},
                emphasis: {
                    areaStyle: {
                        color: 'rgba(255,250,255,0)'
                    }
                },
                data: dlVal
            }]
        };
        let  oRadius = params.radar.radius;
        option.radar.indicator = wdVal,
        option.radar.center = [comConfig.circle.left + '%', comConfig.circle.top+ '%'],
        option.radar.radius = params.radar.radius + '%',
        echart.clear();
        echart.setOption(option);
        option.radar.radius = oRadius,
        echart.resize();
    }
}
